import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';

export const LoadingIndicator = () => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        <div className={'spinnerWrapper'}>
            {promiseInProgress === true ? <div className={'spinner'}></div> : null}
        </div>
    );
};
